/**
 * Liquid Glass A/B (docs/liquid-glass-ab-research.md).
 *
 * Variant B is a per-account flag (`accounts.ui_glass`) that reaches the browser
 * as `data-ui="glass"` on <html>. It has to be <html>, not the shell: the bottom
 * bar (MobileNav) is mounted in the ROOT layout, outside AuthedShell, so nothing
 * inside the shell can scope it.
 *
 * The root layout has no account context, so the flag also lives in a cookie:
 * AuthedShell writes it once the account is known, and the next request paints
 * the attribute from byte zero instead of flashing today's bar for a frame.
 * Only the first load after the toggle changes shows the old bar.
 *
 * Directive-free on purpose: the server layout and a client effect both import
 * from here (anti-pattern #18).
 */
export const UI_VARIANT_COOKIE = 'mucka_ui';
export const UI_GLASS = 'glass';

/** Browser only. Sets or clears the attribute and remembers the choice. */
export function applyUiVariant(glass: boolean): void {
  const root = document.documentElement;
  if (glass) root.dataset.ui = UI_GLASS;
  else delete root.dataset.ui;
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = glass
    ? `${UI_VARIANT_COOKIE}=${UI_GLASS}; Path=/; Max-Age=34560000; SameSite=Lax${secure}`
    : `${UI_VARIANT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}

/**
 * The native glass bar trial (PR 4, docs/liquid-glass-native-bar-plan.md) —
 * `accounts.ui_glass_native`, as `data-ui-native` on <html> beside `data-ui`.
 * No cookie: an app that opens on the web glass bar and swaps to the native
 * one a moment later is acceptable for a trial picked by hand, and a stale
 * cookie that drew a native bar for an account just switched off is not.
 */
export const UI_NATIVE_ATTR = 'uiNative';

/** Browser only. */
export function applyUiNative(on: boolean): void {
  const root = document.documentElement;
  if (on) root.dataset[UI_NATIVE_ATTR] = '1';
  else delete root.dataset[UI_NATIVE_ATTR];
}
